<template>
  <div>
    <user-list :institution-id="institutionData.id" />
  </div>
</template>

<script>
import UserList from './user-list/UserList.vue'

export default {
  components: {
    UserList,
  },
  props: {
    institutionData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
